import '../ui/styles.css';
import { World } from '../core/world';
import { DEFAULT_MODE } from '../core/config/modes';
import { ThreeRenderer } from '../platform/render/three/threeRenderer';
import { WebAudioPlayer } from '../platform/audio/webAudioPlayer';
import { createServices } from '../services';
import { Game } from './game';

// Composition root: pick concrete implementations and start. Swapping the
// renderer, audio backend, or (via VITE_API_BASE_URL) the services happens here
// and nowhere else.
const root = document.getElementById('app');
if (!root) throw new Error('#app container not found');

const world = new World({ mode: DEFAULT_MODE });
const game = new Game({
  world,
  renderer: new ThreeRenderer(),
  audio: new WebAudioPlayer(),
  services: createServices(),
});

void game.start(root);

// Dev-only escape hatch for debugging/testing (e.g. jump levels by bumping
// world.state.elapsed from the console). Stripped from production builds.
if (import.meta.env.DEV) {
  (window as unknown as { __cs: object }).__cs = { world, game };
}
